// src\pages\Customer\CustomerPage.tsx

export const CustomerPage = () => {
    return (
        <div className="">
            Customer Page
        </div>
    )
}

export default CustomerPage